import { render } from "./AppNavigation.vue?vue&type=template&id=108025a4&scoped=true&lang=pug"
import script from "./AppNavigation.vue?vue&type=script&lang=ts"
export * from "./AppNavigation.vue?vue&type=script&lang=ts"

import "./AppNavigation.vue?vue&type=style&index=0&id=108025a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-108025a4"

export default script